import AuthForm from '../components/Auth/AuthForm';
import {useContext, useEffect, useState} from "react";
import PatientContext from "../store/patient-context";
import './SplashAuthPage.css'
import SplashImage from "../components/Auth/SplashImage";


const SplashAuthPage = () => {
  const [showSplash, setShowSplash] = useState(true);
  const patientCtx = useContext(PatientContext);

  useEffect(() => {
    patientCtx.clear();
    setTimeout(() => {setShowSplash(false)}, 1500);
  }, [patientCtx]);

  return (
    <section className={"page_content"}>
      <ol className='slide-container' >
        <li className={showSplash ? 'slide active' : 'slide'} key={1}>
          <SplashImage />
        </li>
        <li className={showSplash ? 'slide' : 'slide active'} key={2}>
          <AuthForm />
        </li>
      </ol>
    </section>);
};

export default SplashAuthPage;
